import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    settings: {},
    loading: {},
    error: null
};

export const settingsSlice = createSlice({
    name: "settingsSlice",
    initialState: init,
    reducers: {
        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch data list
        .addCase(fetchSettings.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchSettings.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.settings = action.payload;
        })
        .addCase(fetchSettings.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Save Settings
        .addCase(saveSettings.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(saveSettings.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.category = action.payload;
        })
        .addCase(saveSettings.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });;
    }
});

export const fetchSettings = createAsyncThunk(
    "productSlice/fetchSettings",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/settings`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch data");
        }
    }
);

export const saveSettings = createAsyncThunk(
    "settingsSlice/saveSettings",
    async ({ settingsData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/settings`, {id: 1, ...settingsData});
            dispatch(fetchSettings());
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to save settings");
        }
    }
);

export const { clearData } = settingsSlice.actions;

export default settingsSlice.reducer;
